module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Rotas\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), (_vm.route.routeId) ? _c('span', [_vm._v(" Rota Nº " + _vm._s(_vm.route.routeId))]) : _c('span', [_vm._v(" Nova Rota")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "min-content"
  }, [_c('div', {
    staticClass: "route-box"
  }, [(_vm.route) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 margin-t20"
  }, [_c('div', {
    staticClass: "route-name-title"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editName),
      expression: "!editName"
    }],
    staticClass: "force-link",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Alterar o nome da rota"
    },
    on: {
      "click": function($event) {
        return _vm.startEditName()
      }
    }
  }, [_c('label', {
    staticClass: "route-title three-dots"
  }, [_vm._v(_vm._s(_vm.route.name))]), _vm._v(" "), _c('i', {
    staticClass: "icon-pencil icon-edit"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editName),
      expression: "editName"
    }],
    staticClass: "editable"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('newName')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "form-control route-label-input",
    attrs: {
      "type": "search",
      "name": "newName",
      "maxlength": "100",
      "placeholder": "Digite o nome da rota",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newName")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "rntrc-box-edit"
  }), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Cancelar edição"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEditName()
      }
    }
  }, [_c('i', {
    staticClass: "icon-cancel-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Salvar edição"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditName()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check-edit"
  })])]), _vm._v(" "), _c('label', {
    staticClass: "route-version"
  }, [_vm._v("v." + _vm._s(_vm.route.version))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    ref: "scrollContainer",
    staticClass: "scroll-ajuste"
  }, _vm._l((_vm.locationPoints), function(w, i) {
    return _c('input-ac', {
      key: w.address + w.sequence,
      ref: "ac",
      refInFor: true,
      attrs: {
        "initLocation": w,
        "sequence": i,
        "totalPoints": _vm.locationPoints.length
      },
      on: {
        "addPoint": _vm.addPoint,
        "removePoint": _vm.removePoint,
        "placeChanged": _vm.placeChanged
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "content-box margin-t30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('i', {
    staticClass: "icon-road"
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Distância:")]), _vm._v("\n                " + _vm._s(_vm.route.totalDistance) + " Km\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "toll-label"
  }, [_vm._v("Pedágios:")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.route.tollFees && _vm.route.tollFees.length))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "time-line"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tempo estimado:")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editTime),
      expression: "!editTime"
    }]
  }, [_vm._v("\n              " + _vm._s(_vm._f("secondsFormat")(_vm.route.totalTime)) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editTime),
      expression: "editTime"
    }],
    staticClass: "editable edit-time"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('newTime')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTime),
      expression: "newTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|max:8'),
      expression: "'min:8|max:8'"
    }, {
      name: "mask-hour",
      rawName: "v-mask-hour"
    }],
    staticClass: "form-control rntrc-label-input",
    attrs: {
      "name": "newTime",
      "placeholder": "dd:hh:mm",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.newTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTime = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('newTime')) ? _c('div', {
    staticClass: "help-block margin-error"
  }, [_vm._v("\n                  Formato inválido\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rntrc-box-edit"
  }), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Cancelar edição"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEditTime()
      }
    }
  }, [_c('i', {
    staticClass: "icon-cancel-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Salvar edição"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEditTime()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check-edit"
  })])])]), _vm._v(" "), (_vm.route.routeId > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-recalculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("\n            Recalcular\n          ")]) : _c('button', {
    staticClass: "btn btn-primary btn-recalculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("\n            Calcular\n          ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "test"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('label', {
    staticClass: "trip-label"
  }, [_vm._v("Informações complementares:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.route.flexField1),
      expression: "route.flexField1"
    }],
    staticClass: "form-control margin-b20",
    attrs: {
      "name": "extra-field-1",
      "id": "extra-field-1",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.route.flexField1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.route, "flexField1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "alert",
    class: _vm.msgClass
  }, [_vm._v("\n          " + _vm._s(_vm.msg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.msgError) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": {
        name: 'routes'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n          Voltar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-save-route",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        return _vm.createRoute()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-check align-icon-left-white"
  }), _vm._v("\n          Salvar\n        ")]), _vm._v(" "), (_vm.routeStatus) ? _c('button', {
    staticClass: "btn btn-danger btn-cancel-adjustments",
    attrs: {
      "disabled": !_vm.route.routeId
    },
    on: {
      "click": _vm.desativar
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  }), _vm._v("\n          Desativar\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.routeStatus) ? _c('button', {
    staticClass: "btn btn-danger btn-cancel-adjustments",
    on: {
      "click": _vm.ativar
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  }), _vm._v("\n          Ativar\n        ")]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-time",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Digite os valores respeitando a sequência: dias, horas e minutos"
    }
  }, [_c('i', {
    staticClass: "icon-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-1358ac6e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/routing/route-detail.vue
// module id = 2049
// module chunks = 1